import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { CloudDownload, ErrorOutline, Print } from "@mui/icons-material";
import { Box, Button, Card, FormControlLabel, FormLabel, Grid, Icon, MenuItem, Radio, RadioGroup, TableFooter, TextField, styled } from "@mui/material";
import { Loader } from "app/components";
import { getAllConstructionNameListByParameters, getAllProjectLocationListForReportsByStatus } from "app/redux/actions/ProjectLocationActions";
import { getConstructionNameBOQContractReport, getConstructionNameBOQEstimateReport } from "app/redux/actions/ReportsAction";
import { AppConstants } from "app/utils/AppConstants";
import { ServiceUrl } from 'app/utils/Constants';
import { getStatusByRole, ProjectStatus } from 'app/utils/ProjectStatus';
import { SnackBarProperty } from "app/utils/SnackBarProperty";
import { addDynamicImage, captureHeader, checkValidation, currencyFormat, getTwoDigitDecimal } from "app/utils/utils";
import { SimpleCard } from "components";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import { ConstructionNameReport } from './constructionNameReport';
import { ConstructionNameBoQDomReport } from './constructionNameBoqDomReport';
import { CostIndexReport } from './costIndexReport';


const styles = {
  tableCell: {
    textAlign: "center"
  },
  subHeader: {
    textAlign: "center",
    fontWeight: 700
  }

}
const DecoratedTextField = styled(TextValidator)(() => ({
  width: "100%",
  marginBottom: "16px",
}));




export const ConstructionNameParentReport = () => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [reportType, setReportType] = useState("cnboq")
  const [isDownloading, setIsDownloading] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const [constructionNameList, setConstructionNameList] = useState([])
  const [projectDetails, setProjectDetails] = useState()
  const [isViewClicked, setIsViewClicked] = useState(false)
  const { reportsProjectLocationList, projectLevelStagePercentage, constructionLevelStagePercentage } = useSelector((state) => state.projectLocation);
  const [tableData, setTableData] = useState()
  const [state, setState] = useState({
    project_location_id: '',
    constructionname_id: ''
  })

  useEffect(() => {
    const statusIds = getStatusByRole()
    dispatch(getAllProjectLocationListForReportsByStatus(statusIds,showLoader, hideLoader, showToast))
  }, []);

  const showLoader = () => {
    setLoading(true)
  }
  const showToast = (msg) => {
    const key = enqueueSnackbar(msg ?? AppConstants.somethingWentWrong, { variant: 'error' });
    SnackBarProperty.error(key, closeSnackbar);
  }

  const hideLoader = () => {
    setLoading(false)
  }
  const handleChange = (event, source) => {
    clearValues()
    if (event.target.name === "project_location_id") {
      const filteredArray = reportsProjectLocationList.filter(project => {
        return project.project_location_id === event.target.value
      });
      state.project_name = filteredArray[0].project_name
      state.project_location_id = filteredArray[0].project_location_id
      state.project_id = filteredArray[0].project_id
      setConstructionNameList([])
      setState({ ...state, [event.target.name]: event.target.value, constructionname_id: '' });
      getAllConstructionNameList(0, filteredArray[0].project_location_id, filteredArray[0].project_id)
    } else {
      setState({ ...state, [event.target.name]: event.target.value });
    }
  }


  const clearValues = () => {
    setReportType('cnboq')
    setIsViewClicked(false)
  }

  const getAllConstructionNameList = (project_location_id, constructionname_id, project_id) => {
    setLoading(true)
    getAllConstructionNameListByParameters(project_location_id, constructionname_id).then((res) => {
      setLoading(false)
      if (res?.status < 300) {
        setConstructionNameList(res?.data)
      } else {
        const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      }
    }).catch(function (error) {
      setLoading(false)
      const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    })
  }

  const handleFormSubmit = () => {
    setIsViewClicked(true)
  }

  const getIsViewClicked = () => {
    return checkValidation(state?.constructionname_id) && checkValidation(state?.project_location_id) && isViewClicked
  }

  return (
    <>
      <div style={{ height: 'auto', width: "100%", padding: '30px', display: "flex", flexDirection: "column", gap: "20px" }}>
        <Grid container>
          <Grid item xs={12}>
            <Button
              size="small"
              sx={{ width: "100px" }}
              variant="contained"
              color="error"
              onClick={() => { window.history.back() }}
            >
              <Icon color="primary" fontSize="small">
                skip_previous
              </Icon>
              Back
            </Button>
          </Grid>
        </Grid>
        <SimpleCard>
          <ValidatorForm onSubmit={handleFormSubmit}>
            <Grid container spacing={3} style={{ marginTop: '-45px', marginBottom: '15px' }} >
              <Grid item xs={12}><b className="font20 extraBold" style={{ color: "#ebad4e" }}>Construction Name</b></Grid>
            </Grid>
            <Grid container spacing={3} >
              <Grid item sm={4} xs={12}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  label="Project ID"
                  id="project_location_id"
                  variant="outlined"
                  name="project_location_id"
                  value={state?.project_location_id}
                  onChange={handleChange}
                  validators={["required"]}
                  errorMessages={["Project ID is required"]}
                >
                  {reportsProjectLocationList?.map((item) => (
                    <MenuItem value={item?.project_location_id} key={item?.project_id}>
                      {item?.project_id}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={4} xs={12}>

                <DecoratedTextField
                  select
                  size="small"
                  fullWidth
                  label="Construction Name"
                  id="constructionname_id"
                  variant="outlined"
                  sx={{ mb: 3 }}
                  name="constructionname_id"
                  value={state?.constructionname_id || ""}
                  onChange={handleChange}
                  validators={["required"]}
                  errorMessages={["Construction Name is required"]}
                >
                  {constructionNameList?.map((item) => (
                    <MenuItem value={item?.constructionname_id} key={item?.constructionname_id}>
                      {item?.construction_name}
                    </MenuItem>
                  ))}
                </DecoratedTextField>

              </Grid>
              <Grid item sm={4} xs={12}>
                <Button size="medium" color="success" variant="contained" type="submit" style={{ marginLeft: 4 }} >View</Button>
              </Grid>
              {getIsViewClicked() &&
              <Grid item xs={12} sx={{mb: 2}}>
                <RadioGroup
                  row
                  name="reportType"
                  value={reportType}
                  onChange={(e) => { setReportType(e.target.value); setTableData([]) }}
                >

                  <FormControlLabel
                    label="Construction Name BoQ"
                    value="cnboq"
                    control={<Radio size="small" color="secondary" />}
                    sx={{ mr: 3, height: 20 }}
                  />
                  <FormControlLabel
                    label="Construction Name BoQ DOM"
                    value="dom"
                    control={<Radio size="small" color="secondary" />}
                    sx={{ height: 20 }}
                  />
                  <FormControlLabel
                    label="Cost Index Details"
                    value="ci"
                    control={<Radio size="small" color="secondary" />}
                    sx={{ height: 20 }}
                  />
                </RadioGroup>
              </Grid>
            }
            </Grid>

          </ValidatorForm>
        </SimpleCard>

        {getIsViewClicked() && reportType === 'cnboq' &&
            <ConstructionNameReport
                state = {state}
            />
        }

        {getIsViewClicked() && reportType === 'dom' &&
            <ConstructionNameBoQDomReport
                state = {state}
            />
        }
        
        {getIsViewClicked() && reportType === 'ci' &&
            <CostIndexReport
                param = {state}
            />
        }

      </div>
      {loading && (
        <Loader
          show={loading}
        />
      )}
      {(isPrinting || isDownloading) && (
        <Loader
          show={isPrinting ? isPrinting : isDownloading}
          text="Processing...Please wait."
        />
      )}

    </>
  )
}